// 文章公共属性
import { z } from "zod";

// 文章公共属性
const BaseArticleSchema = z.object({
    title: z.string(), // 文章标题
    imageUrl: z.string(), // 图片地址
    createTime: z.number(), // 发布时间
    redirectUrl: z.string(), // 文章网页端地址
    originalData: z.unknown().optional(), // 原始数据，可选
});

// 平台特定文章属性
export const ToutiaoArticleSchema = BaseArticleSchema.extend({
    showNum: z.number(), // 展现量
    readNum: z.number(), // 阅读量
    likeNum: z.number(), // 点赞量
    commentNum: z.number(), // 评论量
});
export type ToutiaoArticle = z.infer<typeof ToutiaoArticleSchema>;

export const WeixinArticleSchema = BaseArticleSchema.extend({
    readNum: z.number(), // 阅读人数
    likeNum: z.number(), // 点赞人数
    shareNum: z.number(), // 分享人数
    recommendNum: z.number(), // 推荐人数
});
export type WeixinArticle = z.infer<typeof WeixinArticleSchema>;

export const BaijiahaoArticleSchema = BaseArticleSchema.extend({
    recommendNum: z.number(), // 推荐量
    collectNum: z.number(), // 收藏量
    readNum: z.number(), // 阅读量
    likeNum: z.number(), // 点赞量
    commentNum: z.number(), // 评论量
    shareNum: z.number(), // 转发量
});
export type BaijiahaoArticle = z.infer<typeof BaijiahaoArticleSchema>;

export const XiaohongshuArticleSchema = BaseArticleSchema.extend({
    readNum: z.number(), // 阅读量
    likeNum: z.number(), // 点赞量
    commentNum: z.number(), // 评论量
    collectNum: z.number(), // 收藏量
    shareNum: z.number(), // 转发量
});
export type XiaohongshuArticle = z.infer<typeof XiaohongshuArticleSchema>;

// 响应数据类型
export const FetchArticlesDataSchema = z.object({
    articleCell: z
        .array(z.union([ToutiaoArticleSchema, WeixinArticleSchema, BaijiahaoArticleSchema, XiaohongshuArticleSchema]))
        .optional(),
    timerPublish: z
        .array(z.union([ToutiaoArticleSchema, WeixinArticleSchema, BaijiahaoArticleSchema, XiaohongshuArticleSchema]))
        .optional(),
    pagination: z
        .object({
            total: z.number().optional(), // 总条数
            nextPage: z.boolean().optional(), // 是否有下一页
            lastPage: z.number().optional(), // 用于维系游标所在页，提高查询速度
            cursor: z.number().optional(), // 返回最终游标
            pageNum: z.number(), // 当前页
            pageSize: z.number(), // 每页大小
        })
        .optional(),
});

export type FetchArticlesData = z.infer<typeof FetchArticlesDataSchema>;
export interface FetchArticlesResponse {
    code: number;
    message: string;
    data: FetchArticlesData | Record<string, never>;
}

export const errorResponse = (message: string, code = 500): FetchArticlesResponse => ({
    code,
    message,
    data: {},
});
